import { selectUserInfo } from "features/user/userSlice";
import VerticalTabs from "common/ComponentSidebar/ComponentSideBar";
import { checkPrivileges } from "Helpers/CheckPrivileges";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface tabProps {
  params: any;
  selectedIndex: number;
}
export default function IntegrationTabs(props: tabProps) {
  const navigate = useNavigate();
  const loggedInUserData = useSelector(selectUserInfo);
  const handleChangeTabs = (tabId: number) => {
    if (tabId === 0) navigate(`/business/${props?.params?.id}`);
    else if (tabId === 3)
      navigate(`/business/${props?.params?.id}/integrations`);
    else if (tabId === 4) navigate(`/business/${props?.params?.id}/stations`);
    else if (tabId === 5)
      navigate(`/business/${props?.params?.id}/subscription-analytics`);
  };
  const tabs = [
    { id: 0, title: `Details`, child: <></> },
    { id: 1, title: `branding`, child: <></> },
    { id: 2, title: `themeSettings`, child: <></> },
    { id: 3, title: `integrations`, child: <></> },
    { id: 4, title: `stations`, child: <></> },
    // { id: 5, title: `subscriptionPlanUsage`, child: <></> },
  ];
  const disableTabs = tabs
    .map((tab) => tab.id)
    .filter((tabId) => {
      switch (tabId) {
        case 0:
          return (
            !checkPrivileges("ROLE_BUSINESS_UPDATE") &&
            loggedInUserData?.type !== -1
          );
        case 1:
          return true;
        case 2:
          return true;
        case 3:
          return false;
        case 4:
          return false;
        case 5:
          return false;
        default:
          return false;
      }
    });

  return (
    <>
      <VerticalTabs
        tabs={tabs}
        selectedIndex={props.selectedIndex}
        handleChangeTabs={handleChangeTabs}
        disableTabNo={disableTabs}
      />
    </>
  );
}
